export default "__VITE_ASSET__31ef8b44__"